export enum ContactsPageListScopeId {
  MESSAGES = 'messages',
  EVENTS = 'events',
  ALPHABETICAL = 'alphabetical',
}